import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";

/**
 * bn-panel is a lighter, chromeless section surface (no shadow) with an optional
 * uppercase eyebrow heading — matching the sidebar/section style of bino-cli's
 * control panel. Use it to group related controls or metadata inside a page or a
 * bn-card. For a bordered, elevated container use bn-card instead.
 */
@customElement("bn-panel")
export class BnPanel extends LitElement {
  @property() eyebrow = "";

  static override styles = css`
    :host {
      display: block;
      background: var(--bino-surface-subtle);
      border: 1px solid var(--bino-border);
      border-radius: var(--bino-radius);
      padding: var(--bino-space-md);
    }
    .eyebrow {
      margin: 0 0 var(--bino-space-sm);
      font-family: var(--bino-font-sans);
      font-size: var(--bino-font-size-sm);
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      color: var(--bino-primary);
    }
  `;

  override render() {
    return html`
      ${this.eyebrow ? html`<h3 class="eyebrow">${this.eyebrow}</h3>` : ""}
      <slot></slot>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bn-panel": BnPanel;
  }
}
